// extracted by mini-css-extract-plugin
export default {"wrapper":"IframePopup_wrapper","close":"IframePopup_close"};